const emojiStyling: { paddingTop: string | undefined } = {
    paddingTop: '3px',
}

export default emojiStyling
